import { Grid } from "@mui/material";
import ResponsablesCard from "../../../../../commons/responsables/responsablesCard/ResponsablesCard";
import ResponsablesEnum from "../../../../../enums/responsablesEnum";

const ResponsablesCards = ({ handleOpenDialog, handleEditResponsable }) => {

  return (
    <Grid container spacing={2} >
      <Grid item xs={12} lg={6} xl={4}>
        <ResponsablesCard
          variant="vertical"
          name="responsableEmpresa"
          title="Responsable de Datos"
          handleOpenAddResponsable={handleOpenDialog}
          handleEditResponsable={handleEditResponsable}
          required
          isDatos={true}
        />
      </Grid>
      <Grid item xs={12} lg={6} xl={4}>
        <ResponsablesCard
          variant="vertical"
          name="responsableMedicina"
          responsableType={ResponsablesEnum.representanteMedicinaLaboral}
          title="Responsable de Medicina Laboral"
          handleOpenAddResponsable={handleOpenDialog}
          handleEditResponsable={handleEditResponsable}
          validateHorasMensuales
          horasFieldName="horasMensualesMedicina"
        />
      </Grid>
      <Grid item xs={12} lg={6} xl={4}>
        <ResponsablesCard
          variant="vertical"
          name="responsableSH"
          responsableType={ResponsablesEnum.seguridadHigiene}
          title="Responsable de Seguridad e Higiene"
          handleOpenAddResponsable={handleOpenDialog}
          handleEditResponsable={handleEditResponsable}
          required
          validateHorasMensuales
          horasFieldName="horasMensualesSH"
        />
      </Grid>

    </Grid>
  )
}

export default ResponsablesCards;